import garden from "../assets/images/partners/main-partners/garden.webp";

import camelcoding from "../assets/images/partners/special-partners/camelcoding.webp";
import ecoTinyHouse from "../assets/images/partners/special-partners/eco-tiny-house.webp";
import hamm from "../assets/images/partners/special-partners/hamm.webp";
import magyari from "../assets/images/partners/special-partners/magyari.webp";
import octopus from "../assets/images/partners/special-partners/octopus.webp";

import bergtor from "../assets/images/partners/partners/bergtor.webp";
import bogancs from "../assets/images/partners/partners/bogancs.webp";
import comcolor from "../assets/images/partners/partners/comcolor.webp";
import dreambox from "../assets/images/partners/partners/dreambox.webp";
import ebz from "../assets/images/partners/partners/ebz.webp";
import gazsi from "../assets/images/partners/partners/gazsi.webp";
import hellowuud from "../assets/images/partners/partners/hellowuud.webp";
import hungaro from "../assets/images/partners/partners/hungaro.webp";
import malna from "../assets/images/partners/partners/malna.webp";
import muzal from "../assets/images/partners/partners/muzal.webp";
import perla from "../assets/images/partners/partners/perla.webp";
import petofi from "../assets/images/partners/partners/petofi.webp";
import sculptortech from "../assets/images/partners/partners/sculptortech.webp";
import timian from "../assets/images/partners/partners/timian.webp";

import sPartner1 from "../assets/images/partners/separeted-partners/varoshaza.webp";
import sPartner2 from "../assets/images/partners/separeted-partners/fejlesztesi-ugynokseg.webp";

export const mainPartners = [
  {
    image: garden,
    link: "https://gardenproiect.ro",
  },
];

export const specialPartners = [
  {
    image: camelcoding,
    link: "https://camelcoding.com",
  },
  {
    image: ecoTinyHouse,
    link: "https://ecotiny.house/",
  },
  {
    image: hamm,
    link: "https://www.facebook.com/hammfood",
  },
  {
    image: magyari,
    link: "https://fordharghita.ro/",
  },
  {
    image: octopus,
    link: "https://theoctopus.ro/",
  },
];

export const partners = [
  {
    image: bergtor,
    link: "https://www.bergtor.ro/",
  },
  {
    image: bogancs,
    link: "https://www.facebook.com/bogancs.net",
  },
  {
    image: comcolor,
    link: "https://www.facebook.com/comcolor.ro/",
  },
  {
    image: dreambox,
    link: "https://dreamboxfoto.ro",
  },
  {
    image: ebz,
    link: "https://emokebeautyzone.ro/",
  },
  {
    image: gazsi,
    link: "https://www.facebook.com/p/GAZSI-Manufakt%C3%BAra-100090767311912/",
  },
  {
    image: hellowuud,
    link: "https://hellowuud.ro/",
  },
  {
    image: hungaro,
    link: "https://hungaroresidence.com/",
  },
  {
    image: malna,
    link: "https://www.facebook.com/mastermartipan/",
  },
  {
    image: muzal,
    link: "https://www.facebook.com/muzalporcelain",
  },
  {
    image: perla,
    link: "https://www.perlaharghitei.ro/",
  },
  {
    image: petofi,
    link: "https://www.facebook.com/profile.php?id=100063718923940",
  },
  {
    image: sculptortech,
    link: "https://www.sculptortech.com/",
  },
  {
    image: timian,
    link: "https://www.timian.ro/en",
  },
];

export const separetedPartners = [
  {
    image: sPartner1,
    link: "",
  },
  {
    image: sPartner2,
    link: "",
  },
];
